import React, { useState, useEffect, useRef, forwardRef, useImperativeHandle } from 'react';
import { Col, Row } from 'react-bootstrap';
import { OnlineHighchartsAsync } from './OnlineHighchartsAsync'
import { useTranslation } from 'react-i18next';
import DropdownChartSpeedBreathing from './DropdownChartSpeedBreathing';

const BreathingHighchartsAsyncForwardRef = forwardRef((props, ref) => {
  const { t } = useTranslation();
  const chartComponentRef = useRef(null);  

  useImperativeHandle(ref, () => ({
    setInitialData(data, seriesSettings) {
      chartComponentRef.current.setInitialData(data, seriesSettings);
    },
    setInitialDataForLongSeries(longData, asyncDataLoadUrl, seriesSettings) {
      chartComponentRef.current.setInitialDataForLongSeries(longData, asyncDataLoadUrl, seriesSettings);
    },
    setDataViewMode(mode) {
      chartComponentRef.current.setDataViewMode(mode);
    },
    addNewDataToChart(data, seriesId) {
      chartComponentRef.current.addNewDataToChart(data, seriesId);
    },
    addNewDataToChartLongSeries(data) {
      chartComponentRef.current.addNewDataToChartLongSeries(data)
    },
    setupYAxis(settings) {
      chartComponentRef.current.setupYAxis(settings);    
    },
    scrollToEnd() {
      chartComponentRef.current.scrollToEnd();   
    },
    clearAllChartData() {
      chartComponentRef.current.clearAllChartData();
    }
  }));

  useEffect(() => {    

  }, []);

  const otherChartOptions = {
    chart: {
    },
    xAxis: {
      maxRange: undefined
    },
    yAxis: {
      minRange: 5
    },
    tooltip: {
      valueDecimals: 2,
      valueSuffix: ' Ohm'
    },
    plotOptions: {
      series: {
        //getExtremesFromAll: true,
        point: {
          events: {
            //mouseOver: function () { setHoverData(this.category); }
          }
        },
        dataGrouping: {
          enabled: false,
          anchor: 'middle',          
        }        
      },
      line: {
        dataGrouping: {
          dateTimeLabelFormats: {
            millisecond:  ['%H:%M %S.%Ls', '%H:%M %S.%Ls', '-%H:%M %S.%Ls'],
            second:       ['%H:%M %S.%Ls', '%H:%M %S.%Ls', '-%H:%M %S.%Ls'],
            minute:       ['%H:%M %S.%Ls', '%H:%M %S.%Ls', '-%H:%M %S.%Ls'],
            hour:         ['%H:%M %S.%Ls', '%H:%M %S.%Ls', '-%H:%M %S.%Ls'],
          }
        }
      }
    },
    navigator: {
      handles: {
        enabled: false
      }
    },
    title: {
      text: ''
    }
  };


  return (
    <>
      <Row>
        <Col sm={10}>
          <DropdownChartSpeedBreathing onSelectionChangedCallback={(value) => chartComponentRef.current.setChartExtremesX(value)} /><span className="px-3"></span>          
        </Col>
        <Col>
        </Col>
      </Row>
      <Row>
        <Col className="px-0">
          <OnlineHighchartsAsync ref={chartComponentRef} specificChartOptions={otherChartOptions} seriesName={props.seriesName}
            defaultCellTimeXms={400} />
        </Col>
      </Row>
    </>
  )


});

BreathingHighchartsAsyncForwardRef.displayName = 'BreathingHighchartsAsyncForwardRef';

export const BreathingHighchartsAsync = React.memo(BreathingHighchartsAsyncForwardRef);